import React from 'react';
import { useMutation } from '@apollo/client';
import removeFavoriteCookbookMealMutation from '../RemoveMealFromFavorites/removeFavoriteCookbookMealMutation';
import MealListQuery from '../MealList/CookbookMealListQuery';

interface IRemoveFavoriteCookbookMealConnectorApollo {
  children: ({
    removeCookbookMealFromFavorites,
  }: {
    removeCookbookMealFromFavorites: (mealId: number) => Promise<unknown>;
  }) => React.ReactElement;
}

const RemoveFavoriteCookbookMealConnectorApollo: React.FC<
  IRemoveFavoriteCookbookMealConnectorApollo
> = ({ children }) => {
  const searchCriteria = {
    favoriteMeals: true,
  };
  const [removeMealFromFavorites] = useMutation(removeFavoriteCookbookMealMutation, {
    refetchQueries: [
      {
        query: MealListQuery,
        variables: { searchCriteria },
      },
    ],
  });

  const createRemoveCookbookMealFromFavorites = async (mealId: number) => {
    const response = await removeMealFromFavorites({
      optimisticResponse: {
        cookbook: {
          __typename: 'CookbookMutation',
          removeFavoriteMeal: {
            __typename: 'BasicMutationSuccess',
            code: 200,
          },
        },
      },
      variables: { mealId },
      update: (cache) => {
        cache.modify({
          id: `CookbookMeal:${mealId}`,
          fields: {
            isFavorite() {
              return false;
            },
          },
        });
      },
    });

    return response;
  };

  return children({
    removeCookbookMealFromFavorites: createRemoveCookbookMealFromFavorites,
  });
};

export default RemoveFavoriteCookbookMealConnectorApollo;
